module.exports = __webpack_public_path__ + "static/Dani-261c6a2d71c2d900b82edfbc8d9a62b7.jpg";